export default {
      id: "ic_bet_up-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic_bet_up-usage",
      toString: function () {
        return this.url;
      }
    }